
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moveyouout/privacy-policy",
      function () {
        return require("private-next-pages/moveyouout/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moveyouout/privacy-policy"])
      });
    }
  